const ptBR = {
  metaTitle: 'Programa de Embaixadores WSJ | Indique e Ganhe',
  badge: 'Programa de Embaixadores WSJ',
  heroTitle: 'Indique clientes para a WSJ e ganhe por cada contrato fechado',
  heroSubtitle:
    'Se você conhece empresas que precisam de site, loja online, automação, marketing, aplicativo ou consultoria em tecnologia, torne-se um Embaixador WSJ e receba uma recompensa por cada indicação convertida em venda.',
  heroHighlight: 'Ganhe comissões reais indicando serviços digitais profissionais.',
  heroTrustBadges: ['Pagamento após confirmação', 'Sem meta obrigatória', 'Processo comercial conduzido pela WSJ'],
  btnJoin: 'Quero ser embaixador',
  btnHowItWorks: 'Ver como funciona',
  whatsappMessage: 'Olá! Tenho interesse no Programa de Embaixadores WSJ e gostaria de mais informações.',

  sectionHowTitle: 'Como funciona',
  sectionHowLead: 'Um processo transparente, profissional e orientado a resultados reais — sem promessas vazias.',
  howSteps: [
    { title: 'Você se cadastra', desc: 'Preencha seus dados e solicite participação no programa de embaixadores.' },
    { title: 'Você indica um cliente', desc: 'Envie empresas ou profissionais que precisam de uma solução digital da WSJ.' },
    { title: 'A WSJ fecha o contrato', desc: 'Nossa equipe faz o atendimento, diagnóstico, proposta e fechamento comercial.' },
    { title: 'Você recebe sua recompensa', desc: 'Após o pagamento confirmado pelo cliente, sua comissão é liberada conforme o serviço contratado.' }
  ],

  sectionServicesTitle: 'Serviços que você pode indicar',
  sectionServicesLead: 'Indique qualquer solução digital da WSJ. A comissão varia conforme o tipo e o valor do projeto fechado.',
  services: [
    { title: 'Sites profissionais', desc: 'Presença digital premium para empresas que precisam credibilidade e conversão.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Lojas online / E-commerce', desc: 'Vendas online com catálogo, pagamentos e operação estruturada.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Automações', desc: 'Fluxos inteligentes para reduzir tarefas manuais e acelerar atendimento.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Marketing digital', desc: 'Estratégias para captar clientes, fortalecer marca e gerar oportunidades.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Aplicativos mobile', desc: 'Apps profissionais para Android e iOS alinhados ao negócio.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Consultoria em TI', desc: 'Diagnóstico, arquitetura e evolução tecnológica com visão estratégica.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Sistemas personalizados', desc: 'Soluções sob medida para processos, operação e escala do cliente.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' },
    { title: 'Transporte urbano / soluções digitais', desc: 'Plataformas digitais para mobilidade, operação e experiência do usuário.', commissionNote: 'Comissão definida conforme o valor do projeto fechado.' }
  ],

  sectionCommissionsTitle: 'Como funcionam as comissões',
  sectionCommissionsLead: 'Cada serviço possui uma recompensa diferente, proporcional ao valor do contrato fechado.',
  commissionItems: [
    { title: 'Comissão por contrato fechado', desc: 'A recompensa só é gerada quando o cliente indicado assina e paga o serviço.' },
    { title: 'Pagamento após confirmação', desc: 'Liberação conforme confirmação de pagamento e regras acordadas no programa.' },
    { title: 'Valores por tipo de serviço', desc: 'Projetos maiores e serviços premium podem gerar recompensas maiores.' },
    { title: 'Transparência no processo', desc: 'Você acompanha o status da indicação com a equipe comercial da WSJ.' }
  ],
  commissionDisclaimer:
    'Valores de comissão são definidos pela WSJ conforme tipo de serviço, escopo e valor do contrato. Não há promessa de ganho fixo ou renda garantida.',

  sectionWhoTitle: 'Quem pode indicar',
  sectionWhoLead: 'Você não precisa vender. Você apenas indica. A equipe WSJ conduz o processo comercial.',
  whoCanRefer: [
    'Clientes atuais',
    'Amigos e conhecidos',
    'Profissionais freelancers',
    'Agências parceiras',
    'Consultores',
    'Pessoas com rede de contatos empresariais'
  ],

  sectionIdealTitle: 'Cliente ideal para indicar',
  sectionIdealLead:
    'Empresas que precisam melhorar sua presença digital, vender mais, automatizar processos ou criar uma solução tecnológica profissional.',
  idealClients: [
    'Pequenos negócios que precisam de site profissional',
    'Restaurantes e lojas que querem vender online',
    'Empresas com processos manuais',
    'Prestadores de serviço que precisam captar clientes',
    'Negócios que querem automatizar atendimento',
    'Empresas que precisam de sistema próprio'
  ],

  sectionFormTitle: 'Candidate-se ao programa',
  sectionFormLead: 'Preencha o formulário abaixo. Nossa equipe analisa sua candidatura e entra em contato.',
  formFullName: 'Nome completo',
  formFullNamePlaceholder: 'Seu nome completo',
  formEmail: 'E-mail',
  formEmailPlaceholder: 'seu@email.com',
  formWhatsapp: 'WhatsApp',
  formCountry: 'País',
  formCountryPlaceholder: 'Ex.: Brasil, Portugal',
  formCity: 'Cidade',
  formCityPlaceholder: 'Sua cidade',
  formReferralMethod: 'Como pretende indicar clientes?',
  formReferralMethodPlaceholder: 'Ex.: rede de contatos, clientes atuais, parceiros comerciais…',
  formPaymentDetails: 'Chave Pix / IBAN / forma de pagamento',
  formPaymentDetailsPlaceholder: 'Informe como deseja receber a comissão',
  formTermsLabel: 'Li e aceito os termos do programa de embaixadores',
  formSubmit: 'Enviar candidatura',
  formSubmitting: 'Enviando…',
  formSuccessTitle: 'Candidatura enviada!',
  formSuccessSubtitle: 'Recebemos seus dados. Nossa equipe entrará em contato em breve.',
  formErrorTitle: 'Não foi possível enviar agora',
  formErrorSubtitle: 'Tente novamente ou fale conosco pelo WhatsApp.',
  formWhatsappFallback: 'Falar no WhatsApp',
  formRequired: 'Campo obrigatório',
  formEmailInvalid: 'E-mail inválido',
  formPhoneInvalid: 'Telefone inválido',
  formTermsRequired: 'É necessário aceitar os termos',
  formMessageMin: 'Descreva com pelo menos 10 caracteres',

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Respostas claras sobre participação, comissões e funcionamento do programa.',
  faqItems: [
    { q: 'Quem pode participar?', a: 'Profissionais, parceiros e pessoas com rede de contatos empresariais que desejam indicar clientes para soluções digitais da WSJ, mediante aprovação da candidatura.' },
    { q: 'Quando recebo minha comissão?', a: 'Após o cliente indicado fechar contrato e o pagamento ser confirmado, conforme as regras do programa e o tipo de serviço contratado.' },
    { q: 'Preciso vender o serviço?', a: 'Não. Você apenas indica oportunidades qualificadas. Toda a condução comercial, proposta e fechamento é feita pela equipe WSJ.' },
    { q: 'Existe limite de indicações?', a: 'Não há limite rígido de indicações. Quanto mais oportunidades qualificadas você enviar, maiores as chances de conversão.' },
    { q: 'Como a WSJ sabe que a indicação foi minha?', a: 'Ao enviar a indicação, informe dados de contacto do cliente e contexto. Registramos a origem para garantir rastreabilidade e transparência.' },
    { q: 'Posso indicar empresas fora do Brasil ou Portugal?', a: 'Sim, desde que haja viabilidade comercial e alinhamento com os serviços oferecidos pela WSJ para aquele mercado.' },
    { q: 'A comissão é paga em todos os serviços?', a: 'Sim, para os serviços elegíveis do portfólio WSJ. O valor da comissão varia conforme tipo de projeto e valor do contrato fechado.' },
    { q: 'O que acontece se o cliente não fechar?', a: 'Nenhuma comissão é gerada. A recompensa existe apenas quando há contrato fechado e pagamento confirmado pelo cliente indicado.' }
  ],

  finalCtaTitle: 'Comece agora a indicar clientes e ganhar com a WSJ',
  finalCtaSubtitle: 'Transforme sua rede de contatos em oportunidades reais de negócio.',
  finalCtaButton: 'Quero participar',

  heroVisual: {
    programLabel: 'Programa oficial WSJ',
    stepLabel: 'Fluxo da indicação',
    payoutLabel: 'Liberação',
    payoutValue: 'Após pagamento confirmado',
    trustLabel: 'Modelo transparente',
    trustDesc: 'Sem promessa de renda fácil. Recompensa real por contrato convertido.'
  }
};

const ptPT = {
  ...ptBR,
  metaTitle: 'Programa de Embaixadores WSJ | Indique e Ganhe',
  heroSubtitle:
    'Se conhece empresas que precisam de site, loja online, automação, marketing, aplicação ou consultoria em tecnologia, torne-se Embaixador WSJ e receba uma recompensa por cada indicação convertida em venda.',
  heroTrustBadges: ['Pagamento após confirmação', 'Sem meta obrigatória', 'Processo comercial conduzido pela WSJ'],
  btnJoin: 'Quero ser embaixador',
  btnHowItWorks: 'Ver como funciona',
  whatsappMessage: 'Olá! Tenho interesse no Programa de Embaixadores WSJ e gostaria de mais informações.',
  sectionHowLead: 'Um processo transparente, profissional e orientado a resultados reais — sem promessas vazias.',
  howSteps: [
    { title: 'Regista-se', desc: 'Preencha os seus dados e solicite participação no programa de embaixadores.' },
    { title: 'Indica um cliente', desc: 'Envie empresas ou profissionais que precisam de uma solução digital da WSJ.' },
    { title: 'A WSJ fecha o contrato', desc: 'A nossa equipa faz o atendimento, diagnóstico, proposta e fecho comercial.' },
    { title: 'Recebe a recompensa', desc: 'Após pagamento confirmado pelo cliente, a comissão é libertada conforme o serviço contratado.' }
  ],
  sectionServicesLead: 'Indique qualquer solução digital da WSJ. A comissão varia conforme o tipo e o valor do projeto fechado.',
  services: ptBR.services.map((s) => ({
    ...s,
    commissionNote: 'Comissão definida conforme o valor do projeto fechado.'
  })),
  commissionDisclaimer:
    'Valores de comissão são definidos pela WSJ conforme tipo de serviço, âmbito e valor do contrato. Não há promessa de ganho fixo ou rendimento garantido.',
  sectionWhoLead: 'Não precisa vender. Apenas indica. A equipa WSJ conduz o processo comercial.',
  sectionFormLead: 'Preencha o formulário abaixo. A nossa equipa analisa a candidatura e entra em contacto.',
  formSuccessSubtitle: 'Recebemos os seus dados. A nossa equipa entrará em contacto em breve.',
  formErrorSubtitle: 'Tente novamente ou fale connosco pelo WhatsApp.',
  formTermsRequired: 'É necessário aceitar os termos',
  faqItems: [
    { q: 'Quem pode participar?', a: 'Profissionais, parceiros e pessoas com rede de contactos empresariais que desejam indicar clientes para soluções digitais da WSJ, mediante aprovação da candidatura.' },
    { q: 'Quando recebo a comissão?', a: 'Após o cliente indicado fechar contrato e o pagamento ser confirmado, conforme as regras do programa e o tipo de serviço contratado.' },
    { q: 'Preciso de vender o serviço?', a: 'Não. Apenas indica oportunidades qualificadas. Toda a condução comercial, proposta e fecho é feita pela equipa WSJ.' },
    { q: 'Existe limite de indicações?', a: 'Não há limite rígido. Quanto mais oportunidades qualificadas enviar, maiores as hipóteses de conversão.' },
    { q: 'Como a WSJ sabe que a indicação foi minha?', a: 'Ao enviar a indicação, informe dados de contacto do cliente e contexto. Registamos a origem para garantir rastreabilidade e transparência.' },
    { q: 'Posso indicar empresas fora de Portugal ou Brasil?', a: 'Sim, desde que haja viabilidade comercial e alinhamento com os serviços oferecidos pela WSJ para esse mercado.' },
    { q: 'A comissão é paga em todos os serviços?', a: 'Sim, para os serviços elegíveis do portfólio WSJ. O valor varia conforme tipo de projeto e valor do contrato fechado.' },
    { q: 'O que acontece se o cliente não fechar?', a: 'Nenhuma comissão é gerada. A recompensa existe apenas quando há contrato fechado e pagamento confirmado pelo cliente indicado.' }
  ],
  heroVisual: {
    ...ptBR.heroVisual,
    programLabel: 'Programa oficial WSJ',
    trustDesc: 'Sem promessa de rendimento fácil. Recompensa real por contrato convertido.'
  }
};

const enUS = {
  metaTitle: 'WSJ Ambassadors Programme | Refer & Earn',
  badge: 'WSJ Ambassadors Programme',
  heroTitle: 'Refer clients to WSJ and earn for every closed contract',
  heroSubtitle:
    'If you know businesses that need a website, online store, automation, marketing, mobile app or IT consulting, become a WSJ Ambassador and receive a reward for every referral that converts into a sale.',
  heroHighlight: 'Earn real commissions by referring professional digital services.',
  heroTrustBadges: ['Payout after payment confirmation', 'No mandatory quota', 'Commercial process led by WSJ'],
  btnJoin: 'Become an ambassador',
  btnHowItWorks: 'See how it works',
  whatsappMessage: 'Hello! I am interested in the WSJ Ambassadors Programme and would like more information.',

  sectionHowTitle: 'How it works',
  sectionHowLead: 'A transparent, professional process focused on real outcomes — no empty promises.',
  howSteps: [
    { title: 'You sign up', desc: 'Fill in your details and apply to join the ambassadors programme.' },
    { title: 'You refer a client', desc: 'Send businesses or professionals who need a WSJ digital solution.' },
    { title: 'WSJ closes the deal', desc: 'Our team handles discovery, proposal and commercial closing.' },
    { title: 'You receive your reward', desc: 'After the client payment is confirmed, your commission is released according to the contracted service.' }
  ],

  sectionServicesTitle: 'Services you can refer',
  sectionServicesLead: 'Refer any WSJ digital solution. Commission varies by service type and closed project value.',
  services: [
    { title: 'Professional websites', desc: 'Premium digital presence for businesses that need credibility and conversion.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Online stores / E-commerce', desc: 'Online sales with catalogue, payments and structured operations.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Automation', desc: 'Smart workflows to reduce manual tasks and speed up customer service.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Digital marketing', desc: 'Strategies to attract clients, strengthen brand and generate opportunities.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Mobile apps', desc: 'Professional Android and iOS apps aligned with the business.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'IT consulting', desc: 'Assessment, architecture and technology evolution with strategic vision.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Custom systems', desc: 'Tailored solutions for processes, operations and client scale.', commissionNote: 'Commission based on the closed project value.' },
    { title: 'Urban transport / digital solutions', desc: 'Digital platforms for mobility, operations and user experience.', commissionNote: 'Commission based on the closed project value.' }
  ],

  sectionCommissionsTitle: 'How commissions work',
  sectionCommissionsLead: 'Each service has a different reward, proportional to the closed contract value.',
  commissionItems: [
    { title: 'Commission per closed contract', desc: 'Rewards are only generated when the referred client signs and pays for the service.' },
    { title: 'Payout after confirmation', desc: 'Release according to payment confirmation and programme rules.' },
    { title: 'Values by service type', desc: 'Larger projects and premium services may generate higher rewards.' },
    { title: 'Process transparency', desc: 'Track referral status with the WSJ commercial team.' }
  ],
  commissionDisclaimer:
    'Commission values are defined by WSJ according to service type, scope and contract value. There is no fixed income or guaranteed earnings promise.',

  sectionWhoTitle: 'Who can refer',
  sectionWhoLead: 'You do not need to sell. You only refer. The WSJ team leads the commercial process.',
  whoCanRefer: ['Current clients', 'Friends and contacts', 'Freelance professionals', 'Partner agencies', 'Consultants', 'People with a business network'],

  sectionIdealTitle: 'Ideal client to refer',
  sectionIdealLead:
    'Businesses that need to improve their digital presence, sell more, automate processes or build a professional technology solution.',
  idealClients: [
    'Small businesses that need a professional website',
    'Restaurants and shops that want to sell online',
    'Companies with manual processes',
    'Service providers who need to attract clients',
    'Businesses that want to automate customer service',
    'Companies that need a custom system'
  ],

  sectionFormTitle: 'Apply to the programme',
  sectionFormLead: 'Fill in the form below. Our team will review your application and get in touch.',
  formFullName: 'Full name',
  formFullNamePlaceholder: 'Your full name',
  formEmail: 'Email',
  formEmailPlaceholder: 'you@email.com',
  formWhatsapp: 'WhatsApp',
  formCountry: 'Country',
  formCountryPlaceholder: 'e.g. Brazil, Portugal',
  formCity: 'City',
  formCityPlaceholder: 'Your city',
  formReferralMethod: 'How do you plan to refer clients?',
  formReferralMethodPlaceholder: 'e.g. business network, current clients, commercial partners…',
  formPaymentDetails: 'Pix key / IBAN / payment method',
  formPaymentDetailsPlaceholder: 'How you wish to receive commission',
  formTermsLabel: 'I have read and accept the ambassadors programme terms',
  formSubmit: 'Submit application',
  formSubmitting: 'Sending…',
  formSuccessTitle: 'Application sent!',
  formSuccessSubtitle: 'We received your details. Our team will contact you soon.',
  formErrorTitle: 'Could not send right now',
  formErrorSubtitle: 'Please try again or contact us on WhatsApp.',
  formWhatsappFallback: 'Chat on WhatsApp',
  formRequired: 'Required field',
  formEmailInvalid: 'Invalid email',
  formPhoneInvalid: 'Invalid phone number',
  formTermsRequired: 'You must accept the terms',
  formMessageMin: 'Please describe in at least 10 characters',

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Clear answers about participation, commissions and how the programme works.',
  faqItems: [
    { q: 'Who can participate?', a: 'Professionals, partners and people with business networks who wish to refer clients to WSJ digital solutions, subject to application approval.' },
    { q: 'When do I receive my commission?', a: 'After the referred client closes the contract and payment is confirmed, according to programme rules and the contracted service.' },
    { q: 'Do I need to sell the service?', a: 'No. You only refer qualified opportunities. WSJ handles discovery, proposal and closing.' },
    { q: 'Is there a referral limit?', a: 'There is no strict limit. The more qualified opportunities you send, the higher the conversion potential.' },
    { q: 'How does WSJ know the referral came from me?', a: 'When submitting a referral, provide client contact details and context. We register the source for traceability and transparency.' },
    { q: 'Can I refer businesses outside Brazil or Portugal?', a: 'Yes, as long as there is commercial viability and alignment with WSJ services for that market.' },
    { q: 'Is commission paid on all services?', a: 'Yes, for eligible services in the WSJ portfolio. The amount varies by project type and closed contract value.' },
    { q: 'What if the client does not close?', a: 'No commission is generated. Rewards exist only when there is a closed contract and confirmed payment from the referred client.' }
  ],

  finalCtaTitle: 'Start referring clients and earning with WSJ',
  finalCtaSubtitle: 'Turn your network into real business opportunities.',
  finalCtaButton: 'I want to join',

  heroVisual: {
    programLabel: 'Official WSJ programme',
    stepLabel: 'Referral flow',
    payoutLabel: 'Release',
    payoutValue: 'After confirmed payment',
    trustLabel: 'Transparent model',
    trustDesc: 'No easy-money promises. Real reward for converted contracts.'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const ambassadorsPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
